import _rubyMarkup from "../functions/quill/rubyMarkup.js";
import _stripTags from "../functions/quill/stripTags.js";
import _eol from "eol";
import _convertToPlainTextCustom from "../functions/quill/convertToPlainTextCustom.js";
import _convertToPlainText from "../functions/quill/convertToPlainText.js";
import _convertToHtml from "../functions/quill/convertToHtml.js";
import _getFormatOptions from "../functions/helpers/getFormatOptions.js";
import _removeInvalidEvents from "../functions/eventGroups/removeInvalidEvents.js";
import _tcLib from "../lib/timecode.js";
import _Event from "../classes/event.js";
const Event = _Event;
const tcLib = _tcLib;
const removeInvalidEvents = _removeInvalidEvents;
const getFormatOptions = _getFormatOptions;
const convertToHtml = _convertToHtml;
const convertToPlainText = _convertToPlainText;
const convertToPlainTextCustom = _convertToPlainTextCustom;
const eol = _eol;
const stripTags = _stripTags;
const rubyMarkup = _rubyMarkup;
function extractPositionData(text) {
  // Regular expression to match position data like {\anX}
  var positionRegex = /{\\an(\d+)}/;

  // Use the match method to find the position data
  var match = text.match(positionRegex);
  if (match) {
    // Extract the position value (X)
    var positionValue = parseInt(match[1]);
    return {
      hasPositionData: true,
      position: positionValue
    };
  } else {
    return {
      hasPositionData: false,
      position: null
    };
  }
}
let positionMap = {
  1: {
    x: "start",
    y: "end"
  },
  2: {
    x: "center",
    y: "end"
  },
  3: {
    x: "end",
    y: "end"
  },
  4: {
    x: "start",
    y: "center"
  },
  5: {
    x: "center",
    y: "center"
  },
  6: {
    x: "end",
    y: "center"
  },
  7: {
    x: "start",
    y: "start"
  },
  8: {
    x: "center",
    y: "start"
  },
  9: {
    x: "end",
    y: "top"
  }
};
let positionMapReverse = {
  "start": {
    "start": 7,
    "center": 4,
    "end": 1
  },
  "center": {
    "start": 8,
    "center": 5,
    "end": 2
  },
  "end": {
    "start": 9,
    "center": 6,
    "end": 3
  }
};
export default {
  decode: function (input, options) {
    let events = [],
      eventId,
      tcInfo;
    let subtitleBlocks = input.split("\n\n");
    subtitleBlocks.forEach(block => {
      let ccEvent = new Event();
      let blockInfo = block.split("\n").filter(blockLine => {
        return blockLine !== "";
      });
      if (blockInfo.length > 1) {
        eventId = blockInfo.shift();
        tcInfo = blockInfo.shift();
        ccEvent.start = tcLib.tcMsToSec(tcInfo.split(" --> ")[0], options.frameRate, options.dropFrame);
        ccEvent.end = tcLib.tcMsToSec(tcInfo.split(" --> ")[1], options.frameRate, options.dropFrame);
        let rawText = blockInfo.join("\n");
        try {
          let positionData = extractPositionData(rawText);
          if (positionData.hasPositionData) {
            ccEvent.xPos = positionMap[positionData.position] ? positionMap[positionData.position].x : "center";
            ccEvent.yPos = positionMap[positionData.position] ? positionMap[positionData.position].y : "end";
          }
        } catch (err) {
          console.log("Error parsing positiong data in SRT: ", err.message);
        }
        rawText = rawText.replace(/\\N$/gm, "").replace(/{\\an(\d+)}/gm, "");
        ccEvent.text = convertToHtml(rawText);
        events.push(ccEvent);
      }
    });
    return events;
  },
  encode: function (eventGroup, options) {
    let output = "",
      errors = 0,
      encodingOptions = getFormatOptions(options.formatOptions);
    eventGroup.events = eventGroup.events.filter(event => {
      return stripTags(event.text).trim() !== "";
    });
    eventGroup.events.forEach(function (event, id) {
      try {
        let startMs = tcLib.secToTcMs(event.start, options.frameRate, options.dropFrame);
        let endMs = tcLib.secToTcMs(event.end, options.frameRate, options.dropFrame);
        output += id + 1 - errors + "\n";
        output += startMs + " --> " + endMs + "\n";
        /* Encode Positioning if required */
        if (encodingOptions["Encode Positioning"] && encodingOptions["Encode Positioning"] != "false") {
          let xPos = event.xPos;
          let yPos = event.yPos;

          // Convert integer positions to flexbox values based on percentage
          if (typeof xPos === 'number') {
            const xPercentage = xPos / (options?.window?.width || 32);
            if (xPercentage <= 0.40) {
              xPos = "start";
            } else if (xPercentage >= 0.60) {
              xPos = "end";
            } else {
              xPos = "center";
            }
          }
          if (typeof yPos === 'number') {
            const yPercentage = yPos / (options?.window?.height || 15);
            if (yPercentage <= 0.20) {
              yPos = "start";
            } else if (yPercentage >= 0.50) {
              yPos = "end";
            } else {
              yPos = "center";
            }
          }

          // Default to center/end if position data is missing
          xPos = xPos || "center";
          yPos = yPos || "end";
          output += `{\\an${positionMapReverse[xPos][yPos]}}`;
        }
        if (encodingOptions["Encode Formatting"] && encodingOptions["Encode Formatting"] != "false") {
          let formatted = convertToPlainTextCustom(rubyMarkup.stripJapaneseExtras(event.text), "\n", false, "b", "i", "u");
          if (encodingOptions["Encode Ruby"] === false || encodingOptions["Encode Ruby"] === "false") {
            formatted = rubyMarkup.rubyToBaseOnly(formatted);
          } else {
            formatted = rubyMarkup.rubyToParenthetical(formatted);
          }
          output += formatted + "\n\n";
        } else {
          let plain;
          if (encodingOptions["Encode Ruby"] !== false && encodingOptions["Encode Ruby"] !== "false" && rubyMarkup.hasRuby(event.text)) {
            plain = rubyMarkup.rubyToParenthetical(convertToPlainTextCustom(rubyMarkup.stripJapaneseExtras(event.text), "\n", false, "b", "i", "u")).replace(/<\/?[biu]>/gi, "");
          } else {
            plain = convertToPlainText(rubyMarkup.stripJapaneseExtras(event.text));
          }
          output += plain + "\n\n";
        }
      } catch (e) {
        console.log(e, e.message);
        errors++;
      }
    });
    return output.trim();
  },
  preProcess: {
    encode: function (eventGroup) {
      return removeInvalidEvents(eventGroup);
    },
    decode: function (input) {
      return eol.lf(input).trim().replace(/'(\n){3,}'/gim, "\n\n");
    }
  },
  postProcess: {
    encode: function (output) {
      return output.replace(new RegExp("(\n){3,}", "gim"), "\n\n").replace(/\n\n(?=\D)/gim, "\n").replace(/^ (?=.)/gm, '');
    },
    decode: function (eventGroup) {
      return eventGroup;
    }
  }
};